import { tablet } from "@styles/mixins";
import { colors, typography } from "@styles/vars";
import { createGlobalStyle, css } from "styled-components";
import normalize from "styled-normalize";

export default createGlobalStyle`
    ${normalize}
    
    * {
        box-sizing: border-box;
    }

    body {
        min-height: 100%;
        overflow-x: hidden;
        /* background-image: radial-gradient(50% 193.5% at 50% 50%, #FEFCE5 0%, rgba(255, 255, 255, 0) 100%), linear-gradient(180deg, #FCFCF7 0%, #FFFBF2 100%);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center; */
        background: ${colors.white};
        margin-bottom: 0 !important;
    }

    /* TYPOGRAPHY */
    html, body {
        font-family: ${typography.font};
    }

    h1, h2, h3, h4, .h1, .h2, .h3, .h4, h5, .h5 {
        color: ${colors.black};
        margin: ${typography.margins.m} 0 ${typography.margins.s};
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -1px;

        &:first-child {
            margin-top: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }

    h1, .h1 {
        letter-spacing: -3px;
        font-size: ${typography.sizes.h2};
        line-height: 110%;

        ${tablet(css`
            font-size: ${typography.sizes.h1};
            letter-spacing: -6px;
        `)}
    }

    h2, .h2 {
        line-height: 110%;
        font-size: ${typography.sizes.h3};

        ${tablet(css`
            font-size: ${typography.sizes.h2};
        `)}
    }

    h3, .h3 {
        font-size: ${typography.sizes.h3};
    }

    h4, .h4 {
        font-size: ${typography.sizes.h4};
    }

    p, li {
        color: ${colors.darkGrey};
        font-size: ${typography.sizes.p};
        margin-bottom: ${typography.margins.m};
        font-weight: 400;
        line-height: 150%;
        margin-top: 0;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    ul {
        padding-left: 0;
        margin: 0 0 ${typography.margins.m} 0;

        li {
            list-style-type: disc;
            margin-left: 20px;
            margin-bottom: 5px;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    a {
        cursor: pointer;
        color: ${colors.black};
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }

    b {
        color: ${colors.black};
        font-weight: 700;
    }

    small {
        display: block;
        color: ${colors.darkGrey};
        line-height: 150%;
    }

    hr {
        display: block;
        width: 100%;
        height: 1px;
        background: ${colors.border};
        border: 0;
    }

    .mgb0 {
        margin-bottom: 0;
    }
`